import { Maybe } from '../types';

// This is a hack as we don't have the taxonomy details locally. So instead we look it up directly
// This was taken from a catalogue dump 23.11.23
const taxonomyDefaultImages = {
  '0': 'noimage',
  '1': 'dunger',
  '2': 'dunger',
  '3': 'dunger',
  '4': 'dunger',
  '5': 'noimage',
  '6': 'noimage',
  '7': 'dunger',
  '8': 'noimage',
  '9': 'noimage',
  '10': 'noimage',
  '11': 'noimage',
  '12': 'dunger',
  '13': 'dunger',
  '14': 'dunger',
  '15': 'dunger',
  '16': 'dunger',
  '17': 'dunger',
  '18': 'dunger',
  '19': 'dunger',
  '20': 'dunger',
  '21': 'noimage',
  '22': 'noimage',
  '23': 'PSM',
  '24': 'PSM',
  '25': 'PSM',
  '26': 'PSM',
  '27': 'PSM',
  '28': 'PSM',
  '29': 'PSM',
  '30': 'PSM',
  '31': 'PSM',
  '32': 'seed',
  '33': 'noimage',
  '34': 'noimage',
  '35': 'noimage',
  '36': 'PSM',
  '37': 'PSM',
  '38': 'PSM',
  '39': 'PSM',
  '40': 'PSM',
  '41': 'PSM',
  '42': 'PSM',
  '43': 'PSM',
  '44': 'noimage',
  '45': null,
  '46': null,
  '47': 'seed',
  '48': 'seed',
  '49': 'seed',
  '50': 'seed',
  '51': 'seed',
  '52': 'seed',
  '53': 'seed',
};

type PArticle = {
  image?: Maybe<string>;
  taxonomyId: string;
};

function getItemImage(image: string) {
  return `/catalogue/images/${encodeURIComponent(image)}`;
}

function getDefaultImage(taxonomyImage: string | null | undefined): string {
  return `/catalogue/noimage/${taxonomyImage || 'noimage'}`;
}

export const getCatalogueImage = (
  env: { VITE_STATIC_URL: string },
  image: string | null | undefined,
  taxonomyImage: string | null | undefined,
) => {
  const staticUrl = env.VITE_STATIC_URL;
  const path = image ? getItemImage(image) : getDefaultImage(taxonomyImage);

  return `${staticUrl}${path}.webp`;
};
